import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import { Modal, HeadingText } from '@paypalcorp/pp-react'
import styles from './crowdfunding_cover.less'
import CrowdFundingCoverImage from 'components/crowdfunding_cover_image'
import CrowdFundingPreview from 'components/pages/crowdfunding/crowdfunding_preview'
import { trackClick } from 'lib/fpti_analytics'

import { getI18n } from 'client/i18n'

export const I18N_CONTEXT = 'components/pages/crowdfunding/crowdfunding_cover'
const i18n = getI18n(I18N_CONTEXT)

class CrowdFundingCover extends React.Component {
  static propTypes = {
    fields: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    onChangeCover: PropTypes.func,
    setData: PropTypes.func,
    submit: PropTypes.func,
    anyInactiveFieldsTouchedWithError: PropTypes.bool.isRequired,
    gradientColor: PropTypes.string,
    backgroundImage: PropTypes.string,
    backgroundPan: PropTypes.number,
    isAndroid: PropTypes.bool,
    shouldAutoFocus: PropTypes.bool,
    countryCode: PropTypes.string,
    locale: PropTypes.string,
  }

  static defaultProps = {
    countryCode: 'US',
    locale: 'en_US',
  }

  state = {
    isOpen: false,
  }

  setData() {
    this.props.setData({
      background_image: this.props.fields.backgroundImage.value,
      background_image_filename: this.props.fields.backgroundImageFilename
        .value,
      background_pan: this.props.fields.backgroundPan.value,
    })
  }
  handleModalClick = e => {
    e.preventDefault()
    this.setData()
    this.setState({ isOpen: true })
    trackClick({
      clickName: 'preview',
      data: {
        flow: 'crowdfunding',
      },
    })
  }

  handleModalClose = () => {
    this.setState({ isOpen: false })
    trackClick({
      clickName: 'close',
      data: {
        flow: 'crowdfunding',
      },
    })
  }

  handleSubmit = e => {
    e.preventDefault()
    this.setData()
    return this.props
      .submit(`${GLOBAL_CONSTS.REQUEST_URI}/c/create-crowdfunding/publish`)
      .then(() => {
        trackClick({
          clickName: 'publish',
          data: {
            flow: 'crowdfunding',
          },
        })
      })
  }

  render() {
    const {
      anyInactiveFieldsTouchedWithError,
      countryCode,
      locale,
    } = this.props

    const termsAndConditionLink = `/${countryCode}/webapps/mpp/ua/generositynetwork-tnc?locale.x=${locale}`

    return (
      <form>
        <HeadingText size="md" styleName="title">
          {i18n('title')}
        </HeadingText>

        <div styleName="uploader">
          <CrowdFundingCoverImage fields={this.props.fields} />
        </div>

        <button
          onClick={this.handleModalClick}
          styleName="btn"
          data-pa-click="next"
          className={`vx_btn vx_btn-secondary vx_btn-block ${
            anyInactiveFieldsTouchedWithError ? 'vx_btn-disabled' : ''
          }`}
          disabled={anyInactiveFieldsTouchedWithError}
          data-nemo="preview-next"
          type="button"
        >
          {i18n('preview')}
        </button>
        <button
          onClick={this.handleSubmit}
          styleName="btn"
          data-pa-click="next"
          className={`vx_btn vx_btn-primary vx_btn-block ${
            anyInactiveFieldsTouchedWithError ? 'vx_btn-disabled' : ''
          }`}
          disabled={anyInactiveFieldsTouchedWithError}
          data-nemo="agree-publish"
          type="button"
        >
          {i18n('publish')}
        </button>
        <p
          styleName="disclaimer"
          dangerouslySetInnerHTML={{
            __html: i18n('disclaimer', {
              tc_link: termsAndConditionLink,
            }),
          }}
        />
        <Modal
          isOpen={this.state.isOpen}
          onClose={this.handleModalClose}
          styleName="modal"
          action={
            <HeadingText size="md" styleName="modal_title">
              {i18n('preview')}
            </HeadingText>
          }
        >
          <CrowdFundingPreview />
        </Modal>
      </form>
    )
  }
}

export default cssModules(CrowdFundingCover, styles)
